import { render, staticRenderFns } from "./SSOConfigPage.vue?vue&type=template&id=06480835&scoped=true&"
import script from "./SSOConfigPage.vue?vue&type=script&lang=js&"
export * from "./SSOConfigPage.vue?vue&type=script&lang=js&"
import style0 from "./SSOConfigPage.vue?vue&type=style&index=0&id=06480835&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06480835",
  null
  
)

export default component.exports